import React from 'react';
import { Navigate } from 'react-router-dom';

// Keep old bookmarks usable; account registration belongs to eis ekosis.
const Register: React.FC = () => <Navigate to="/login" replace />;

export default Register;
